import { render, staticRenderFns } from "./StatsCounter.vue?vue&type=template&id=51739fec"
import script from "./StatsCounter.vue?vue&type=script&lang=js"
export * from "./StatsCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports